import { render, staticRenderFns } from "./XTable.vue?vue&type=template&id=dd7d426e&scoped=true"
import script from "./XTable.vue?vue&type=script&lang=js"
export * from "./XTable.vue?vue&type=script&lang=js"
import style0 from "./XTable.vue?vue&type=style&index=0&id=dd7d426e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7d426e",
  null
  
)

export default component.exports